import React, {ReactElement} from 'react';
import {useIntl} from 'react-intl';
import {useStaticQuery, graphql} from 'gatsby';

import HubHero from '../DesignSystem/HubHero/HubHero';
import {TagProps} from '../DesignSystem/TagsButtons/TagsButtons';
import {useLocale, Locale} from '../../RootProvider/LocaleContext';
import {getPageRoute} from '../../utils/routes/getPageRoute';
import {getNodesByLocale} from '../../localeUtils/getNodesByLocale';
import getFlags from '../../flagGetter';
import {ALL_TAG} from '../DesignSystem/TagsButtons/constants';

interface Props {
  selectedTag?: string;
  title?: string;
}

interface ContentfulKnowledgePageCategory {
  displayOnLocale: string[];
  node_locale: string;
  title: string;
  slug: string;
}

function KnowledgeHubHero({selectedTag, title}: Props): ReactElement {
  const FLAGS = getFlags();
  const {formatMessage, locale: language} = useIntl();
  const locale = useLocale();
  const data = useStaticQuery(graphql`
    query KnowledgeHubHero {
      allContentfulKnowledgeCategories(
        sort: {fields: [order], order: ASC}
        filter: {excludeCategoryFromIndex: {ne: true}}
      ) {
        nodes {
          slug
          title
          displayOnLocale
          node_locale
        }
      }
    }
  `);

  const tagsToShow = getNodesByLocale<ContentfulKnowledgePageCategory>(
    data.allContentfulKnowledgeCategories.nodes,
    locale,
    language as Locale
  );

  const formattedTags = tagsToShow.map(
    (node: ContentfulKnowledgePageCategory): TagProps => ({
      label: node.title,
      tag: node.slug,
      url: getPageRoute('knowledge.category', locale, {contentfulSlug: node.slug}),
    })
  );

  // manually add an "all" tag at the start of the tags
  const allTags = [
    {
      label: formatMessage({id: 'knowledge.category.all'}),
      tag: ALL_TAG,
      url: getPageRoute('knowledge.home', locale),
    },
    ...formattedTags,
  ];

  return (
    <HubHero
      title={title || formatMessage({id: 'knowledge.hub.title'})}
      description={formatMessage({id: 'knowledgeHub.description'})}
      handleSearch={
        FLAGS.KNOWLEDGE_HUB_SEARCH
          ? () => {
              // noop
            }
          : undefined
      }
      searchBarPlaceholder={formatMessage({id: 'knowledgeHub.search.placeholder'})}
      selectedTag={selectedTag}
      tags={allTags}
    />
  );
}

export default KnowledgeHubHero;
